import { all, takeLatest } from "redux-saga/effects";

import { AuthTypes } from "../ducks/auth";
import { signIn, getUser } from "./auth";

import { MessagesTypes } from "../ducks/messages";
import {
  getMessages,
  postMessages,
  refreshMessages,
  updateMessage,
  getPendingMessages
} from "./messages";

import { UsersTypes } from "../ducks/users";
import { getUsers } from "./users";

export default function* rootSaga() {
  return yield all([
    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn),
    takeLatest(AuthTypes.GET_USER, getUser),

    takeLatest(MessagesTypes.GET_MESSAGES, getMessages),
    takeLatest(MessagesTypes.POST_MESSAGES, postMessages),
    takeLatest(MessagesTypes.REFRESH_MESSAGES, refreshMessages),
    takeLatest(MessagesTypes.UPDATE_MESSAGE, updateMessage),
    takeLatest(MessagesTypes.GET_PENDING_MESSAGES, getPendingMessages),

    takeLatest(UsersTypes.GET_USERS, getUsers)
  ]);
}



// WEBPACK FOOTER //
// ./src/storeChat/sagas/index.js